

<app-crud-edit
  [sectionTitle]="sectionTitle"
  [buttonTitle]="buttonTitle"
  [entityroot]="entityrooturl"
  [onSubmit]="onSubmitHandler()"
  [onCancel]="onCancelHandler()"
  [form]="form"
  [fields]="fields"
  [options]="options"
  [model]="model"
  [isReady]="isReady"
  [isSubmitting]="isSubmitting"
>
  <div class="row no-gutters">
    <div class="col-12">
      <label class="sr-only">Market groups</label>
      <div class="button-group mb-2">
        <ng-container *ngFor="let marketGroup of marketGroups">
          <button type="button" (click)="onClickMarketGroup(marketGroup.id)" class="btn btn-sm btn-outline-secondary">{{marketGroup.label}}</button>
        </ng-container>
      </div>
    </div>
  </div>
</app-crud-edit>
<!--{{model | json}}-->


<!--Add here a specific component to integrate external url like a frame integration-->
<!--<iframe width="100%" height="100%" frameBorder="0" [src]="getSafeUrl('https://biel-bienne-portal.localdev.ch/')"></iframe>-->
